var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.List.name !== '' && !_vm.liveMode)?_c('div',{staticClass:"breadCrumbContainer paddingNormal"},[_c('a',{attrs:{"href":_vm.List.url},domProps:{"innerHTML":_vm._s(_vm.List.name)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }